import { Outlet } from 'react-router-dom';

import { useAuth } from '@/app/auth';
import AppLayout from '@/components/AppLayout/AppLayout';
import AppLoader from '@/components/AppLoader/AppLoader';
import LoginScreen from '@/features/auth/LoginScreen';
import UnauthorizedScreen from '@/features/auth/UnauthorizedScreen';
import ThemeApplier from '@/features/theme/ThemeApplier';

export default function App() {
  const { status } = useAuth();

  if (status === 'loading') {
    return (
      <>
        <ThemeApplier />
        <AppLoader tasks={[{ id: 'auth', label: 'Authenticating', status: 'loading' }]} />
      </>
    );
  }

  if (status === 'unauthenticated') {
    return (
      <>
        <ThemeApplier />
        <LoginScreen />
      </>
    );
  }

  if (status === 'unauthorized') {
    return (
      <>
        <ThemeApplier />
        <UnauthorizedScreen />
      </>
    );
  }

  return (
    <>
      <ThemeApplier />
      <AppLayout>
        <Outlet />
      </AppLayout>
    </>
  );
}
